module.exports = __webpack_public_path__ + "a33ef65a0c274063977f15aba1ec6bc0.png";